/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Node as ProseMirrorNode } from "prosemirror-model";
export function createTocCommand() {
    return (match, view) => {
        const tocJSON = getTocJSON(view.state.doc.toJSON().content);
        const { tr } = view.state;
        const { from, to } = match.range;
        const node = ProseMirrorNode.fromJSON(view.state.schema, tocJSON);
        // use `from - 1` here since ToC creation is always triggered from inside a paragraph (from slash commands suggester)
        // that way we remove the paragraph and replace it by the ToC node if the match suggester is the only content
        tr.replaceWith(from - 1, to, node);
        view.dispatch(tr);
    };
}
export function getTocJSON(items, expanded = false) {
    const headers = getHeadingTree(items.filter((node) => node.type === "heading"));
    const toc = {
        type: "toc",
        attrs: { expanded },
        content: [getTocList(headers)],
    };
    return toc;
}
/**
 * Transform flat heading list to nested tree structure.
 *
 * @param headers The list of header elements in json representation.
 * @returns List of header with nested childs headers.
 */
function getHeadingTree(headers) {
    const tree = [];
    let path = clearPath(tree);
    let stack = [];
    let pathLevel;
    for (const header of headers) {
        const level = header.attrs.level;
        const item = { ...header, childs: [] };
        if (!pathLevel) {
            pathLevel = level - 1;
        }
        if (level === 1) {
            path = { ...clearPath(tree), 1: item };
            stack = tree;
        }
        updatePath(path, item);
        if (level !== 1 && level !== pathLevel) {
            stack = path[level - 1].childs;
        }
        pathLevel = level;
        stack.push(item);
    }
    return tree;
}
function clearPath(tree) {
    return { 0: { childs: tree } };
}
/**
 * Update path. In case there is no parent recursivly fill with empty headers.
 *
 * @param path Dict with tree structure to track childs.
 * @param item Header tree item. Can be empty.
 */
function updatePath(path, item) {
    const { empty, level } = item.attrs;
    const prev = level - 1;
    path[level] = item;
    // empty, but have previous level, add it to childs
    if (empty && path[prev]) {
        path[prev].childs.push(item);
    }
    // no previous level, fill it with empty header.
    if (!path[prev]) {
        const header = getEmptyHeader(prev, empty ? [item] : []);
        updatePath(path, header);
    }
}
function getEmptyHeader(level, childs = [], text = "-") {
    return {
        type: "heading",
        content: [{ type: "text", text }],
        attrs: { level, empty: true },
        childs,
    };
}
function getTocList(headers) {
    const items = headers.length ? headers : [getEmptyHeader(1, [], "empty")];
    return {
        type: "bullet_list",
        content: items.map(getTocItem),
    };
}
function getTocItem(header) {
    const item = {
        type: "list_item",
        content: getItemContent(header),
    };
    if (header.childs.length) {
        item.content = [...item.content, getTocList(header.childs)];
    }
    return item;
}
export function getItemContent(header) {
    var _a;
    const text = (_a = header.content) === null || _a === void 0 ? void 0 : _a[0].text; // TODO: probably there is a better way to get text
    if (!text) {
        return [];
    }
    return [
        {
            type: "paragraph",
            attrs: { textAlign: null, size: "medium" },
            content: [
                {
                    type: "text",
                    marks: [
                        {
                            type: "link",
                            attrs: {
                                href: `#${header.attrs.id}`,
                            },
                        },
                    ],
                    text,
                },
            ],
        },
    ];
}
